<template>
  <div id="land_box">
    <div class="land_content">
      <div class="mian_box">
        <div class="mian_top">管理登陆</div>
        <div class="mian_left">
          <div class="mian_left_title">
            <span class="show">账号密码登陆</span>
            <!--<span>手机验证登陆</span>-->
          </div>
          <div class="land_li">
            <el-input placeholder="请输入内容" v-model="accountVle">
              <i slot="prefix" class="el-icon-user"></i>
            </el-input>
          </div>
          <div class="land_li">
            <el-input
              placeholder="请输入内容"
              v-model="passwordVle"
              show-password
              @keyup.enter.native="landFn"
            >
              <i slot="prefix" class="el-icon-goods"></i>
            </el-input>
          </div>

          <button v-if="loadingShow == 1" class="land_btn" @click="landFn">登录</button>
          <el-button v-else class="land_btn" type="primary" :loading="true"
            >登录中</el-button
          >
        </div>
        <div class="mian_right">
          <img src="../../../static/image/banner.jpg" />
          <div class="text">香味研究所介绍</div>
        </div>
      </div>
    </div>
    <div class="icp-footer">浙ICP备2023032140号-5</div>
  </div>
</template>

<script>
import { getRoute } from "../../router";
export default {
  data() {
    return {
      // 登陆
      loadingShow: 1,

      accountVle: "",
      passwordVle: "",

      accountList: [
        {
          account: "admin",
          password: "123456",
        },
      ],
    };
  },
  created() {},
  mounted() {
    // 每个接口都需要token，判断是否是登录之后（登录前没有token）
    let token = this.$store.state.TOKEN;
    if (token) {
      let arr = token.split("_");
      let time = new Date().valueOf();
      if (time < arr[0]) {
        let path = "/brand";
        let router = getRoute(0);
        this.$router.options.routes = router;
        this.$router.addRoutes(router);
        this.$router.push({ path: path });
      }
    }
  },
  methods: {
    //账号登陆
    landFn: function (res) {
      var accountVle = this.accountVle;
      var passwordVle = this.passwordVle;
      var data = this.accountList;
      if (!accountVle) {
        this.$message.error("账号不能为空");
        return false;
      }

      if (!passwordVle) {
        this.$message.error("密码不能为空");
        return false;
      }

      this.$https(
        this.$api.api.Login,
        {
          username: accountVle,
          password: passwordVle,
        },
        "POST"
      ).then((res) => {
        if (res.data.code == 200) {
          var path = "",
            router = "";

          let time = new Date().valueOf() + 2 * 60 * 60 * 1000;
          // let time = new Date().valueOf() + (30*1000)
          let token = time + "_" + res.data.data.id;

          var obj = {
            token: token,
            data: 5555,
          };

          obj.account = "超级管理员";
          sessionStorage.setItem("USER", JSON.stringify(obj));
          sessionStorage.setItem("TOKEN", JSON.stringify(token));
          if (obj) {
            path = "/goodsOrder/consignmentOrder";
            router = getRoute(1);
          } else {
            path = "/Login";
            router = getRoute(0);
          }

          this.$store.commit("setToken", obj.token);
          this.$router.options.routes = router;
          this.$router.addRoutes(router);
          this.$router.push({ path: path });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
#land_box {
  background: #fff;
  position: relative;
  min-height: 100vh;

  .el-button.is-loading {
    width: 90%;
    margin: 15px auto;
  }

  .land_content {
    margin: auto;
    line-height: 40px;

    .mian_box {
      width: 600px;
      height: 300px;
      background: #fff;
      border: 1px solid #eeeeee;
      position: absolute;
      transform: translate(-50%, -50%);
      top: 45%;
      left: 50%;
      padding: 0px 20px;

      .mian_top {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        font-weight: bold;
        border-bottom: 1px solid #eeeeee;
      }

      .mian_left {
        width: 46%;
        height: 260px;
        float: left;
        padding: 10px 2%;

        .mian_left_title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          display: flex;
          justify-content: space-around;
          border-bottom: 1px solid #eeeeee;
          font-size: 15px;
          cursor: pointer;
        }

        .land_li {
          width: 90%;
          margin: 15px auto;
        }

        .land_btn {
          width: 90%;
          height: 40px;
          line-height: 40px;
          background: #17a1f6;
          text-align: center;
          margin: auto;
          border-radius: 5px;
          cursor: pointer;
          display: block;
          border: 0;
          font-size: 15px;
          color: #fff;
          padding: 0;
        }
      }

      .mian_right {
        width: 49%;
        height: 260px;
        float: left;
        border-left: 1px solid #eeeeee;

        img {
          width: 220px;
          margin: auto;
          display: block;
          padding-top: 50px;
          box-sizing: border-box;
        }

        .text {
          width: 100%;
          text-align: center;
          font-size: 16px;
          letter-spacing: 3px;
        }
      }
    }
  }

  .icp-footer {
    position: absolute;
    bottom: 130px;
    width: 100%;
    text-align: center;
    color: #666;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue